import { memo } from 'react'
import st from './NetworkIcon.module.scss'

const NetworkIcon = memo(() => {
	return <div className={st.netIcon} />
})

export default NetworkIcon
